<template>
  <div id="quickModule">
    <div class="card-left">
      <div class="title flex-align">
        <div>
          <img style="width: 32px;height: 32px;margin-right: 10px;" src="@/assets/icons/ic-statistics.png">
          <span>{{ $t('pages_main_051') }}</span>
          <span>{{ $t('pages_main_052') }}</span>
        </div>
        <div class="date-select">
          <a-button
            size="small"
            style="font-size: 12px"
            :type="searchQuery.scope === 'WEEK' ? 'link' : 'text'"
            @click="dateClick('WEEK')"
          >{{ $t('pages_main_048') }}</a-button>
          <a-button
            size="small"
            style="font-size: 12px"
            :type="searchQuery.scope === 'MONTH' ? 'link' : 'text'"
            @click="dateClick('MONTH')"
          >{{ $t('pages_main_049') }}</a-button>
          <a-button
            size="small"
            style="font-size: 12px"
            :type="searchQuery.scope === 'YEAR' ? 'link' : 'text'"
            @click="dateClick('YEAR')"
          >{{ $t('pages_main_050') }}</a-button>
        </div>
      </div>
      <!-- <div class="left-list">
        <div class="module-info">
          <div class="name">
            {{ $t('pages_router_003') }}
          </div>
          <a-skeleton v-if="tradeLoading" active :paragraph="false" />
          <a-tooltip v-else :title="tradeInfo.receiveAmt">
            <div class="amount">{{ tradeInfo.receiveAmt }}</div>
          </a-tooltip>
        </div>
        <div class="module-info">
          <div class="name">{{ $t('pages_router_016') }}</div>
          <a-skeleton v-if="tradeLoading" active :paragraph="false" />
          <a-tooltip v-else :title="tradeInfo.exchangeAmt">
            <div class="amount">{{ tradeInfo.exchangeAmt }}</div>
          </a-tooltip>
        </div>
        <div class="module-info">
          <div class="name">{{ $t('pages_router_007') }}</div>
          <a-skeleton v-if="tradeLoading" active :paragraph="false" />
          <a-tooltip v-else :title="tradeInfo.payAmt">
            <div class="amount">{{ tradeInfo.payAmt }}</div>
          </a-tooltip>
        </div>
      </div> -->
      <div class="line-charts">
        <div v-show="!tradeLoading && !isLine" id="lineEmpty" class="flex-align" style="justify-content: center">
          <a-empty :image="simpleImage" />
        </div>
        <div v-show="tradeLoading && !isLine" id="lineLoading" class="flex-align">
          <a-spin />
        </div>
        <div v-show="!tradeLoading && isLine" id="tradeCharts" />
      </div>
    </div>
    <div class="card-right">
      <div class="title">
        <img style="width: 32px;height: 32px;margin-right: 10px;" src="@/assets/icons/ic-toBoList.png">
        {{ $t('pages_main_012') }}</div>
      <div class="right-list">
        <div class="module-info" @click="$router.push('/receive/manage')">
          <div class="name">{{ $t('pages_main_014') }}</div>
          <a-skeleton v-if="waitLoading" active :paragraph="false" />
          <div v-else class="amount">{{ waitInfo.receive }}</div>
        </div>
        <div class="module-info" @click="$router.push({ path: '/funds/review', query: { key: 'outbound' } })">
          <div class="name">{{ $t('pages_main_021') }}</div>
          <a-skeleton v-if="waitLoading" active :paragraph="false" />
          <div v-else class="amount">{{ waitInfo.outPay }}</div>
        </div>
        <!-- <div class="module-info" @click="$router.push({ path: '/funds/review', query: { key: 'inbound' } })">
          <div class="name">{{ $t('pages_main_020') }}</div>
          <a-skeleton v-if="waitLoading" active :paragraph="false" />
          <div v-else class="amount">{{ waitInfo.pay }}</div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, computed, nextTick } from 'vue'
import { _home } from '@/api/index'
import { Empty } from 'ant-design-vue'
import { parseMoney } from '@/util'
import i18n from '@/locale'
import * as echarts from 'echarts'
export default {
  name: 'QuickModule',
  setup() {
    const state = reactive({
      waitLoading: true,
      tradeLoading: true,
      isLine: true,
      waitInfo: {},
      tradeInfo: {},
      searchQuery: {
        scope: 'YEAR'
      }
    })
    state.simpleImage = computed(() => {
      return Empty.PRESENTED_IMAGE_SIMPLE
    })
    const dateClick = (scope) => {
      state.searchQuery.scope = scope
      loadTradeRatio()
    }

    onMounted(() => loadTradeRatio())
    const renderLineCharts = (data) => {
      const myChart = echarts.init(document.getElementById('tradeCharts'))
      myChart.resize({
        height: 200
      })
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          type: 'category',
          data: [i18n.global.t('pages_router_003'), i18n.global.t('pages_router_016'), i18n.global.t('pages_router_007')]
        },
        series: [
          {
            type: 'bar',
            barWidth: 10,
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#CAB95D00' },
                { offset: 0.5, color: '#CAB95D' },
                { offset: 1, color: '#CAB95D' }
              ]),
              borderRadius: [5, 5, 5, 5]
            },
            name: '$',
            data
            // data: [data.receiveAmt, data.exchangeAmt, data.payAmt]
            // data: [data.receiveAmount ? parseMoney(data.receiveAmount) : 0, data.exchangeAmount ? parseMoney(data.exchangeAmount) : 0, data.payAmount ? parseMoney(data.payAmount) : 0]
          }
        ]
      }
      myChart.setOption(option)
    }
    const loadTradeRatio = async () => {
      state.tradeLoading = true
      state.isLine = false
      const res = await _home.getTradeRatio(state.searchQuery)
      if (res.data.succ) {
        const { data } = res.data
        state.tradeInfo = Object.assign({}, res.data.data, {
          receiveAmt: data.receiveAmount ? `$${parseMoney(data.receiveAmount)}` : 0,
          exchangeAmt: data.exchangeAmount ? `$${parseMoney(data.exchangeAmount)}` : 0,
          payAmt: data.payAmount ? `$${parseMoney(data.payAmount)}` : 0
        })
        const dataLine = Object.assign({}, res.data.data, {
          receiveAmt: data.receiveAmount ? Number(parseMoney(data.receiveAmount)) : 0,
          exchangeAmt: data.exchangeAmount ? Number(parseMoney(data.exchangeAmount)) : 0,
          payAmt: data.payAmount ? Number(parseMoney(data.payAmount)) : 0
        })
        state.isLine = true
        nextTick(() => {
          renderLineCharts([dataLine.receiveAmount, dataLine.exchangeAmount, dataLine.payAmount])
        })
      }
      state.tradeLoading = false
    }

    const loadBusStatistics = async () => {
      state.waitLoading = true
      const res = await _home.getBusStatistics()
      if (res.data.succ) {
        state.waitInfo = res.data.data
      }
      state.waitLoading = false
    }

    const init = () => {
      loadBusStatistics()
    }

    init()
    return {
      dateClick,
      loadTradeRatio,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#quickModule {
  margin-top: 18px;
  display: flex;
  .card-left, .card-right {
    padding: 18px 24px 18px 32px;
    border-radius: 8px;
    background: #fff;

    .line-charts {
      background: #fff;
      width: 100%;
      border-radius: 20px;
      height: 200px;
      margin-right: 20px;
      position: relative;

      .charts-title,
      .pie-title {
        position: absolute;
        left: 0;
        font-size: 18px;
        font-weight: 600;
        padding: 20px 20px 10px 20px;
      }
      #tradeCharts,
      #lineEmpty,
      #lineLoading {
        flex: 1;
        height: 200px;
        justify-content: center;
      }

      #tradeCharts,
      #lineEmpty,
      #lineLoading {
        flex: 1.5;
      }
    }

    .title {
      font-size: 18px;
      font-weight: 500;
      text-align: left;
      span:nth-child(3) {
        margin-left: 5px;
        font-size: 14px;
        color: #666;
      }
      .date-select {
        margin-left: auto;
      }
    }
    .left-list, .right-list {
      display: flex;
      padding: 18px 12px;
      margin-top: 18px;
      flex-wrap: wrap;
      height: 100px;
      border: 1px solid #BA8438;
      border-radius: 8px;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      // border: 1px solid transparent;
      // background-image: linear-gradient(to right, #fff, #fff), linear-gradient(230deg, #4065e0, #de3c1a);
      .module-info {
        flex: 0 0 33.33%;
        border-right: 1px solid #ECEFFC;
        padding: 0 12px;
        overflow: hidden;
        cursor: pointer;
        .ellipsis {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .name {
          .ellipsis;
          color: #BA8438;
          font-weight: 500;
        }
        .amount {
          .ellipsis;
          margin-top: 8px;
          font-size: 20px;
          font-weight: 500;
          color: #333;
        }
      }
      .module-info:last-child {
        border-right: 0;
      }
    }
  }
  .card-left{
    flex: 0 0 58%;
  }
  .card-right {
    flex: 0 0 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 2%;
  }
}
</style>
